module.exports = __webpack_public_path__ + "img/wb2@2x.c0dcc5ef.png";